<template>
  <div :class="footerClass">
      <slot></slot>
  </div>
</template>

<script>
    export default {
        props: {
            footerClass: {
                type: String,
                default: 'uk-width-medium-1-1 uk-margin-top'
            }
        },
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/components/FormFooter.vue